import type { EntityPerm } from '../context/AuthContext';

export function isAdminUser(entities: EntityPerm[] | null | undefined): boolean {
  return (entities ?? []).some((e) => e.role === 'admin');
}

export function isTesoreroUser(entities: EntityPerm[] | null | undefined): boolean {
  const list = entities ?? [];
  if (isAdminUser(list)) return false;
  return list.some((e) => e.role === 'tesorero');
}

export function homePathForUser(entities: EntityPerm[] | null | undefined): string {
  return isTesoreroUser(entities) ? '/portal' : '/admin/tesoreria';
}

export function firstNameFromUser(displayName: string | null, username?: string | null, email?: string | null): string {
  const raw = (displayName || username || email?.split('@')[0] || 'scout').trim();
  const first = raw.split(/\s+/)[0] || raw;
  return first.charAt(0).toUpperCase() + first.slice(1);
}

export function welcomeShownKey(userId: number | null): string {
  return `tesoreria_welcome_${userId ?? 'anon'}`;
}

const ADMIN_TAGLINES = [
  'A darle duro a la jornada.',
  'Hoy también se cuadra la caja.',
  'La tesorería te estaba esperando.',
];

export function adminTagline(userId: number | null): string {
  const idx = Math.abs(userId ?? 0) % ADMIN_TAGLINES.length;
  return ADMIN_TAGLINES[idx];
}
